import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnDestroy,
  Renderer2,
  input
} from '@angular/core';

export interface InnerAttributeConfig {
  selector?: string;   // CSS selector inside host (default: 'a')
  attr: string;        // attribute name, e.g. 'href', 'role', 'aria-label'
  value: string;       // value to set when missing/empty
}

@Directive({
  selector: '[appInnerAttribute]',
  standalone: true,
})
export class InnerAttributeDirective implements AfterViewInit, OnDestroy {
  readonly config = input.required<InnerAttributeConfig>({ alias: "appInnerAttribute" });

  private observer?: MutationObserver;

  constructor(
    private host: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.ensureOnTargets();

    this.observer = new MutationObserver(() => this.ensureOnTargets());
    this.observer.observe(this.host.nativeElement, {
      childList: true,
      subtree: true,
    });
  }

  private ensureOnTargets(): void {
    const config = this.config();
    if (!config || !config.attr || !config.value) {
      return;
    }

    const selector = config.selector || 'a';
    const root = this.host.nativeElement;
    const elements = root.querySelectorAll<HTMLElement>(selector);

    elements.forEach((el) => {
      const current = el.getAttribute(this.config().attr);
      if (!current || current.trim() === '') {
        this.renderer.setAttribute(el, this.config().attr, this.config().value);
      }
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}